<template>
  <el-row class="no-location">
    <p id="info">
      {{ $t("Usrs_donot_have_ponds_in_loc_click_here_to") }}
    </p>
    <er-button
      btnType="circle_add"
      :showLabel="true"
      :showIcon="true"
      size="mini"
      @click="handleAddPondClick"
      :disabled="disabled"
    >
      <slot>
        <p style="text-transform: uppercase;">{{ $t("Comn_add_pond") }}</p>
      </slot>
    </er-button>
  </el-row>
</template>

<script>
import errorHandlerMixin from "@/mixins/errorHandlerMixin.js";

export default {
  name: "NoPonds",
  mixins: [errorHandlerMixin],
  props: {
    tabData: {
      default: {}
    },
    disabled: {
      default: false
    }
  },
  methods: {
    handleAddPondClick() {
      try {
        this.isEditable(this.tabData);
        this.$router.push("map-view");
      } catch (error) {
        this.errorMessages(error, true);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.no-location {
  display: flex;
  align-items: center;
  padding-top: 48px;
  padding-bottom: 48px;
  background: white;
  #info {
    margin-right: 8px;
    margin-left: 16px;
    @include responsiveProperty(
      font-size,
      $app_font_size_small,
      $app_font_size_1,
      $app_font_size_2
    );
  }
  .el-button {
    p {
      text-transform: uppercase;
    }
  }
}
</style>
